// extracted by mini-css-extract-plugin
export default {"bannerContainer":"HomeComponent_bannerContainer__nwD2f","mainContainer":"HomeComponent_mainContainer__WdYqU"};